'use strict';

var Event = require('../util/event');

/**
 * 采集AJAX和资源的性能和成功率，以及错误信息
 * 
 * @param {ResManager} resManager
 */
module.exports = function (resManager) {
    var cfgManager = resManager.cfgManager;
    if (cfgManager.get('autoCatch').ajax) {
        //  ajax的性能
        Event.on('ajaxCall', function () {
            resManager.parseAjax.apply(resManager, arguments);
        });
    }
    var ADD_EVENT = window.addEventListener || window.attachEvent;

    if (cfgManager.get('autoCatch').resource) {
        //  只关心load之前的资源请求情况
        if (document && document.readyState === 'complete') {
            resManager.handleResourceTiming.apply(resManager, arguments);
        } else {
            ADD_EVENT('load', function () {
                //  CSS/JS 资源请求时间统计
                resManager.handleResourceTiming.apply(resManager, arguments);
            });
        }

        //  监听资源加载出错
        ADD_EVENT('error', function (event) {
            if (event) {
                resManager.handleResourceLoadError.apply(resManager, arguments);
            }
        }, true);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/resource/catch.js
// module id = 252
// module chunks = 0